import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { KeypadConfigType } from '../../interfaces/key-pad-config.enum';
import { KeyPadDisplayOption } from '../../interfaces/key-pad-config.type';
import { IKeyPadButton } from './keypad-panel.types';
import { E2E_ATTRIBUTES } from '@app/shared/types';

@Component({
  selector: 'xea-keypad-panel',
  templateUrl: './keypad-panel.component.html',
  styleUrls: ['./keypad-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KeypadPanelComponent implements OnInit {
  @Input() public keyPadType: KeypadConfigType | KeyPadDisplayOption;
  @Input() public keypadInputValue: any;
  @Input() public title: string;
  @Input() public keyPadButtons: IKeyPadButton[];

  @Input() public isClosable: boolean = false;

  /**
   * is flexible true, the keypad will be flexible and will take the full width of the container.
   * If false, the keypad will be fixed and will take the width of the keypad buttons.
   */
  @Input() public flexible: boolean;

  @Output() public keyPadValueChange: EventEmitter<string | number> = new EventEmitter();

  @Output() public close: EventEmitter<void> = new EventEmitter();

  public readonly e2e = E2E_ATTRIBUTES;

  public constructor() {}

  public ngOnInit() {}

  public onKeyPadInput(value: string | number): void {
    this.keyPadValueChange.emit(value);
  }

  public onClose(): void {
    this.close.emit();
  }
}
